var _rect, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2448",
    style: {
      enableBackground: "new 0 0 2500 2448"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99135"
    },
    d: "M0,0h2500v2448H0V0z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 192,
    width: 2125,
    height: 2066
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F99135"
    },
    points: "1255,1717 1174,1438 874.3,1438 793.3,1717 587.9,1717 877,730.1 877,622 1152.6,622 1482.1,1717 "
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "912,1246 1133.6,1246 1022.8,816.3 "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1579,
    y: 914.5,
    style: {
      fill: "#F99135"
    },
    width: 181.7,
    height: 802.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99135"
    },
    d: "M1669.8,802.8c-52.9,0-96-42.4-96-94.8s42.9-94.8,96-94.8c52.9,0,96,42.4,96,94.8 S1722.9,802.8,1669.8,802.8z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrator);
export default __webpack_public_path__ + "static/media/illustrator.e0f7757af0e533ef9a5f500263327304.svg";
export { ForwardRef as ReactComponent };